import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect, useState } from "react";
import MenuEntry from "./MenuEntry";
import MenuList from "./MenuList";

const MenuAccordion = ({
  accordionEntry,
  browserUri,
  pathname,
  onMobileClose,
  isNested = false,
}) => {
  // Funzione ricorsiva per controllare se un URI è contenuto nell'albero
  const containsUri = (entries, uri) => {
    if (!entries || !Array.isArray(entries)) return false;

    return entries.some((entry) => {
      if (entry.uri === uri) return true;

      if (entry.type === "accordion" && entry.entries) {
        return containsUri(entry.entries, uri);
      }

      if (entry.type === "list" && entry.entries) {
        return entry.entries.some((subEntry) => subEntry.uri === uri);
      }

      return false;
    });
  };

  const [expanded, setExpanded] = useState(
    containsUri(accordionEntry.entries, browserUri),
  );

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  useEffect(() => {
    setExpanded(containsUri(accordionEntry.entries, browserUri));
  }, [browserUri, accordionEntry.entries]);

  const isActiveGroup = expanded === true;

  const renderEntry = (entry, index) => {
    switch (entry.type) {
      case "accordion":
        return (
          <MenuAccordion
            key={`${entry.title}-${index}`}
            accordionEntry={entry}
            browserUri={browserUri}
            pathname={pathname}
            onMobileClose={onMobileClose}
            isNested={true}
          />
        );
      case "list":
        return (
          <MenuList
            key={`${entry.title}-${index}`}
            listEntry={entry}
            browserUri={browserUri}
            onMobileClose={onMobileClose}
          />
        );
      case "link":
      default:
        return (
          <MenuEntry
            key={`${entry.uri}-${index}`}
            entry={entry}
            browserUri={browserUri}
            pathname={pathname}
            className={"inside"}
            onMobileClose={onMobileClose}
          />
        );
    }
  };

  return (
    <Accordion
      elevation={0}
      onChange={handleChange(true)}
      expanded={expanded}
      defaultExpanded={accordionEntry.expanded}
      disableGutters
      className={`menu-accordion ${isActiveGroup ? 'active' : ''} ${isNested ? 'nested' : ''}`}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon className="expand-icon" />}
        className="accordion-summary"
        sx={{
    '& .MuiAccordionSummary-expandIconWrapper': {
      transform: 'rotate(-90deg)',
      transition: 'transform 0.3s'
    },
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(0deg)'
    }
  }}
      >
        <Typography
          variant="subtitle2"
          className={`accordion-title ${isActiveGroup ? 'active' : ''}`}
        >
          {accordionEntry.title}
        </Typography>
      </AccordionSummary>

      <AccordionDetails className="accordion-details">
        {accordionEntry.entries.map((entry, entryIndex) => renderEntry(entry, entryIndex))}
      </AccordionDetails>
    </Accordion>
  );
};

export default MenuAccordion;